'use client';
import React, { useRef, FC } from 'react';

import { useIsDesktop } from '@/hooks/useIsDesktop';
import { TypeFullVideoSectionFields } from '@/core/generated-types/TypeFullVideoSection';
import useIntersectionObserver from '@/hooks/useIntersectionObserver';

export const VideoSection: FC<TypeFullVideoSectionFields> = ({
  mediaDesktop,
  mediaMobile,
  autoplay = true,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const isDesktop = useIsDesktop();
  const media = isDesktop ? mediaDesktop : mediaMobile;
  useIntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (videoRef.current) {
        if (entry.isIntersecting) {
          const newSrc =
            media && media?.fields && 'video' in media?.fields
              ? media?.fields?.video?.fields?.file?.url
              : '';
          const hasSrcChanged =
            newSrc && !videoRef.current.src.includes(newSrc);
          if (hasSrcChanged) {
            videoRef.current.src = newSrc;
            // Force video element to reload its source
            videoRef.current.load();
            return;
          }
          videoRef.current.play();
        } else {
          videoRef.current.pause();
        }
      }
    });
  }, videoRef);

  return (
    <div className="w-full">
      <video
        poster={media?.fields.poster?.fields.file.url}
        data-testid="full-video-section"
        ref={videoRef}
        className="w-full h-full"
        playsInline
        autoPlay={autoplay}
        loop
        muted
      ></video>
    </div>
  );
};

export default VideoSection;
